import { IRootState } from '../../../store'
import { IAlertState } from '../store/alert.types'

export const getAlertSelector = (state: IRootState): IAlertState => state.alert
